/**
 * A custom cell renderer for displaying owner information in a grid.
 * 
 * This component renders the owner name using the OwnerRenderer component.
 * If the owner name value is null, undefined, not a string, or an empty string,
 * the renderer returns null instead of attempting to render anything.
 * 
 * @param params - The cell renderer parameters from ag-Grid
 * @param params.value - The value to be rendered, expected to be the owner name as a string
 * @returns JSX Element of OwnerRenderer component or null if the value is invalid
 */
import type { CustomCellRendererProps } from 'ag-grid-react';
import OwnerRenderer from '../OwnerRenderer';


export default (params: CustomCellRendererProps) => {
	if (params.value === null || params.value === undefined || typeof params.value !== 'string' || params.value.trim() === '') {
		// If the ownerName is not available or not a valid string, return null
		return null;
	}

	return <OwnerRenderer ownerName={params.value}/>;
};
